<template>
  <div class="cs-videoList">
    <el-button v-if="listType === 1" v-show="stepIndex === 1" size="small" class="cs-videoList-btnReturn"
      @click="onReturnClick">返回</el-button>
    <el-row>
      <el-col>
        <pagination v-show="stepIndex === 1" v-loading="loading" :data="listData" @loadData="onListDataLoad"
          :option="paginationOption" @pageSizeChange="pageSizeChange" @currentPageChange="currentPageChange"
          @customEvent="customEventHandler" @edit="onEdit"></pagination>
        <pagination v-show="stepIndex !== 1" v-loading="loading" :data="vaCoursePageData"
          @loadData="onVACoursePageDataLoad" :option="vaCoursePaginationOption" @pageSizeChange="vaCoursePageSizeChange"
          @currentPageChange="vaCourseCurrentPageChange" @customEvent="vaCourseCustomEventHandler"></pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getVACoursePageData,
  getVideoAppointmentList
} from "../service/videoAppointment.service";
import pagination from "./common/pagination";
import global_ from "@/core/global";

export default {
  props: {
    listType: Number, //1 视频列表, 2 预约列表
    isActive: Boolean,
  },
  data() {
    return {
      bypassVideoAppointment: global_.bypassVideoAppointment,
      stepIndex: 0,
      selectCourse: null,
      loading: false,
      vaCoursePageData: {},
      listData: {},
      vaCoursePaginationOption: {},
      paginationOption: {},
      vaCourseSearchKeyword: "",
      searchKeyword: "",
      vaCoursePageSize: 20,
      pageSize: 20,
      watchHistoryListVisible: false,
      isLoadedData: false,
    };
  },
  components: {
    pagination,
  },
  created() {
    this.vaCoursePaginationOption = {
      isVideoSite: true,
      displayPagination: true,
      hasEditButton: false,
      hasAddButton: false,
      hasSearch: false,
      hasDeleteButton: false,
    };
    this.paginationOption = {
      isVideoSite: true,
      displayPagination: true,
      hasEditButton: true,
      editButtonText: "历史记录",
      hasAddButton: false,
      hasSearch: false,
      hasDeleteButton: false,
      displayStudent: false,
      bypassVideoAppointment: this.bypassVideoAppointment,
    };

    this.init();
  },
  mounted() { },
  methods: {
    onReturnClick() {
      this.stepIndex = 0;
      this.selectCourse = null;
    },
    init() {
      if (!this.isActive || this.isLoadedData) {
        return;
      }
      this.isLoadedData = true;
      if (this.listType === 1) {
        this.stepIndex = 0;
        this.searchVACoursePageData();
      } else {
        this.stepIndex = 1;
        this.search();
      }

    },
    getVACourseSearchPageData(pageNumber) {
      if (typeof pageNumber == "undefined") {
        pageNumber = 1;
      }

      let additionalFilter = {
        IsVideoSite: true,
        IsAppointment: this.listType === 2
      };

      let pageData = {
        pageSize: this.vaCoursePageSize,
        pageNumber: pageNumber,
        keyWord: this.vaCourseSearchKeyword,
        startDate: "",
        endDate: "",
        additionalFilter: additionalFilter,
      };
      return pageData;
    },
    searchVACoursePageData(pageNumber) {
      let pageData = this.getVACourseSearchPageData(pageNumber);
      this.getVACoursePageDataFromServer(pageData);
    },
    getVACoursePageDataFromServer(pageData) {
      this.loading = true;
      getVACoursePageData(pageData).then((result) => {
        if (result && result.success) {
          this.vaCoursePageData = result.data;
        }
        this.loading = false;
      });
    },
    onVACoursePageDataLoad(pageData) {
      this.searchVACoursePageData(pageData.pageNumber);
    },
    vaCoursePageSizeChange(value) {
      this.vaCoursePageSize = value;
    },
    vaCourseCurrentPageChange(value) {
      this.vaCoursePageData.CurrentPage = value;
    },
    vaCourseCustomEventHandler(data) {
      if (data.action === "view") {
        this.selectCourse = data.data;
        this.stepIndex = 1;
        this.search();
      }
    },

    getSearchPageData(pageNumber) {
      if (typeof pageNumber == "undefined") {
        pageNumber = 1;
      }

      let additionalFilter = {
        IsVideoSite: true,
        IsAppointment: this.listType === 2
      };

      if (!!this.selectCourse) {
        additionalFilter.CourseId = this.selectCourse.CourseId;
        additionalFilter.TeacherId = this.selectCourse.TeacherId;
      }

      let pageData = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        keyWord: this.searchKeyword,
        startDate: "",
        endDate: "",
        additionalFilter: additionalFilter,
      };
      return pageData;
    },
    search(pageNumber) {
      let pageData = this.getSearchPageData(pageNumber);
      this.getListData(pageData);
    },
    getListData(pageData) {
      this.loading = true;
      getVideoAppointmentList(pageData).then((result) => {
        if (result && result.success) {
          this.listData = result.data;
        }
        this.loading = false;
      });
    },
    onListDataLoad(pageData) {
      this.search(pageData.pageNumber);
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.listData.CurrentPage = value;
    },
    async customEventHandler(data) {
      if (data.name == "view"){
        let row = data.row;
        if (row.IsAppointment){
          if (row.IsCompleted){
            this.$message.warning("该预约课节已观看完毕，无可用观看时长");
            return;
          }
          //this.showTokenEditor(row.Id);
        }
      }
      
      this.$emit("customEvent", data);
      
      if (data.name == "reload") {
        this.search();
      }
    },
    onEdit(index, row) {
      this.showWatchHistoryList(row);
    },
    showWatchHistoryList(row) {
      this.$emit("showWatchHistoryList", row);
    },
    updateListDataRow(){
      this.listData.Results.forEach((x) => {
        if (x.Id != row.Id) {
          if (x.IsFreeWatchCountInTerm) {
            x.SignInStatus = x.SignInText;// + "(需缴费)";
          }
        }
      });
    }
  },
  watch: {
    isActive: function () {
      this.init();
    }
  },
};
</script>

<style lang="scss" scoped>
.grid-content {
  /deep/ .el-table .cell {
    white-space: pre-line;
  }

  margin-top: 10px;
}
.cs-videoList{
  .cs-videoList-btnReturn{
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 99;
  }

  /deep/ .cs-pagination-table-container{
    margin-top: 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/videoList.vue